<template>
  <div class="main-content">
    <QuestionList
      :tableData="tableData"
      :page="page"
      :isDisabled="true"
      @handleSearch="handleSearch"
      @handleReset="handleReset"
      @handleCreate="handleCreate"
      @handleEdit="handleEdit"
      @handleDelete="handleDelete"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    />

    <QuestionForm ref="formRef" @success="handleSearch" />
  </div>
</template>

<script>
import {
  questionManageList,
  questionManageDelete,
} from "@/api/question/manage";
import { mapGetters } from "vuex";
import { mobilePhoneRule } from "@/utils/formRules";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import QuestionForm from "./questionForm.vue";
import QuestionList from "../components/questionList.vue";
export default {
  name: "index",
  components: {
    FormImgUpload,
    QuestionForm,
    QuestionList,
  },
  // computed: {
  // 	...mapGetters(['getButton'])
  // },
  data() {
    return {
      button: {},
      isDetails: false,
      searchData: {
        code: "",
        title: "",
        type: "",
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [], //列表数据
      showLoading: false,
      showLoadingForm: false, //防重提交

      dialogVisible: false,

      dialogPassWordVisible: false,
      dataUrl: "",
    };
  },
  created() {
    this.onLoad();
  },
  methods: {
    //初始化
    onLoad() {
      const searchForm = {
        path: this.$route.path,
        searchData: this.searchData,
      };
      this.showLoading = true;
      questionManageList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records.map((item, index) => {
            return {
              ...item,
              isChecked: false,
              indexOf:
                (this.page.currentPage - 1) * this.page.pageSize + index + 1,
            };
          });
          this.page.total = res.data.total;
        }
      });
    },
    //图片上传
    upload(e) {
      if (Array.isArray(e)) {
        this.form.image = [...e];
      } else {
        this.form.image = [...this.form.image, e];
      }
    },
    // 添加
    // handleCreate() {
    //   this.form.image = [];
    //   this.isDetails = false;
    //   this.form.id = "";
    //   this.dialogVisible = true;
    // },
    handleCreate(type) {
      this.$refs.formRef.open(type);
    },
    // 编辑
    handleEdit(row) {
      console.log(row, "zhe;li");
      this.$refs.formRef.open("edit", row);
    },
    // 删除
    handleDelete(row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        questionManageDelete(row.id).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            this.onLoad();
          }
        });
      });
    },
    // 查询
    handleSearch(e) {
      this.page.currentPage = 1;
      this.searchData = { ...e };
      this.onLoad();
    },
    // 重置
    handleReset() {
      this.searchData = {
        code: "",
        title: "",
        type: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },

    // 分页
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.onLoad();
    },
    handleCurrentChange(page) {
      this.page.currentPage = page;
      this.onLoad();
    },
  },
};
</script>

<style scoped>
.copy {
  cursor: pointer;
  /* width: 60px; */
  margin-left: 15px;
  color: #66b1ff;
}
.tips {
  font-size: 20px;
  line-height: 1;
  margin-bottom: 30px;
}
img {
  width: 100%;
  height: 100%;
}
</style>
